import React, { useEffect, useRef, useState } from "react"
import { FaTimes } from "react-icons/fa"
import { useSelector } from "react-redux"

import { Modal, Select } from "components"
import { getAllCategories } from "services"
import StrmrmFoodsSearch from "./StrmrmFoodsSearch"
import StrmrmRequestedItems from "./StrmrmRequestedItems"
import StrmrmFooter from "./StrmrmFooter"
import classes from "./index.module.scss"

const StrMakeRequestModal = (props) => {
  const {
    openMakeRequestModal,
    setOpenMakeRequestModal,
    setStockTransferRequests,
    stockTransferRequestForEdit
  } = props

  const cashierBranchId =
    useSelector(state => state.userAccountInfo.branchId)

  const systemBranches =
    useSelector(state => state.systemBranches)
      .filter(sb => sb._id !== cashierBranchId)

  const [sourceBranchId, setSourceBranchId] = useState("")
  const [requestedItems, setRequestedItems] = useState({})
  const [categories, setCategories] = useState(null)
  const [selectedFoodOptions, setSelectedFoodOptions] = useState({})

  const unmount = useRef(false)

  const handleExited = () => {
    setSourceBranchId("")

    setRequestedItems({})

    setSelectedFoodOptions({})
  }

  const handleChangeBranch = (select) => {
    setSourceBranchId(select.value)

    setRequestedItems({})

    setSelectedFoodOptions({})

  }

  const fillForm = () => {
    if (!stockTransferRequestForEdit) return

    const selectedFoodOptions = {}

    stockTransferRequestForEdit.requestedItems.forEach(ri => {
      selectedFoodOptions[ri.optionId] = {
        foodId: ri.foodId,
        optionId: ri.optionId,
        foodName: ri.foodName,
        unit: ri.unit,
        isSimple: ri.isSimple,
        foodOptionName: ri.foodOptionName,
        foodImageCover: ri.foodImageCover
      }
    })

    const requestedItems = {}

    stockTransferRequestForEdit.requestedItems.forEach(ri => {
      requestedItems[ri.optionId] = {
        foodId: ri.foodId,
        optionId: ri.optionId,
        requestedQuantity: String(ri.requestedQuantity)
      }
    })

    setSourceBranchId(
      stockTransferRequestForEdit.sourceBranchId
    )

    setSelectedFoodOptions(
      selectedFoodOptions
    )

    setRequestedItems(
      requestedItems
    )
  }

  const getCategories = async () => {
    if (categories !== null) return

    try {
      const response = await getAllCategories()

      setCategories(response)
    } catch (err) {
      console.log(err)
    }
  }

  const handleEnter = () => {
    fillForm()

    getCategories()
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const destinationBranchOptions =
    systemBranches !== null
      ?
      systemBranches.map(sb => ({
        label: sb.name,
        value: sb._id
      }))
      : []

  const destinationBranchSelectValue =
    destinationBranchOptions.find(bo =>
      bo.value === sourceBranchId
    )

  const showRequestedItems =
    Object.keys(selectedFoodOptions).length > 0

  const editMode =
    !!stockTransferRequestForEdit

  return (
    <Modal
      
      size="lg"
      backdrop="static"
      onEnter={handleEnter}
      onExited={handleExited}
      show={openMakeRequestModal}
      onHide={() => setOpenMakeRequestModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button onClick={() => setOpenMakeRequestModal(false)}>
            <FaTimes />
          </button>
        </div>
        <div className={classes["row"]}>
          <Select
            isDisabled={editMode}
            label="شعبه درخواست"
            noOptionsMessage={() => "هیچ شعبه ای یافت نشد"}
            options={destinationBranchOptions}
            className={classes["select"]}
            onChange={handleChangeBranch}
            value={destinationBranchSelectValue}
          />
        </div>
        {!!sourceBranchId
          ?
          <StrmrmFoodsSearch
            categories={categories}
            setCategories={setCategories}
            selectedFoodOptions={selectedFoodOptions}
            setSelectedFoodOptions={setSelectedFoodOptions}
            sourceBranchId={sourceBranchId}
          />
          :
          <div className={classes["no-branch"]}>
            ابتدا شعبه مقصد را انتخاب کنید
          </div>
        }

        {
          showRequestedItems &&
          <StrmrmRequestedItems
            requestedItems={requestedItems}
            setRequestedItems={setRequestedItems}
            selectedFoodOptions={selectedFoodOptions}
            setSelectedFoodOptions={setSelectedFoodOptions}
          />
        }

        <StrmrmFooter
          editMode={editMode}
          sourceBranchId={sourceBranchId}
          requestedItems={requestedItems}
          setOpenMakeRequestModal={setOpenMakeRequestModal}
          setStockTransferRequests={setStockTransferRequests}
          stockTransferRequestForEdit={stockTransferRequestForEdit}
        />
      </div>
    </Modal>
  )
}

export default StrMakeRequestModal